export default "__VITE_ASSET__BYUJKOdR__"